
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './Home.css';

export default function Home() {
    return (
        <Container fluid>
            <Row>
                <Col>Home</Col>
            </Row>
        </Container>
    );
}